import React, { useEffect, useRef, useState } from 'react'
import {
  CoursePlayListHeader,
  LoaderContainer,
  MinimizeButton,
  OpenPlaylistButton,
  PlayerBackgroundContainer,
  PlayerBackgroundOverlay,
  PlayerDetailsRow,
  PlayerDetailText,
  PlayerDetailTextItems,
  PlayerSessionImage,
  PlayListContainerPopup,
  StyledDrawer,
  StyledHeaderButton,
  StyledPlayer,
  StyledPlayerContainer,
  StyledPlayerHeader,
} from './PlayerStyle'
import { APP_CONSTANTS, backgroundImage, LOOPED_PLAYER } from '../../constants'
import ReactPlayer from 'react-player'
import { CourseDetails } from './CourseDetails'
import { CoursePlayList } from './CoursePlayList'
import PlayerControls from './PlayerControls'
import { getSessionProgressData } from '../../helpers/playerHelper'
import { putSessionProgress } from '../../services/playerService'
import DeviceDetector from 'device-detector-js'
import { v4 as uuidv4 } from 'uuid'
import dayjs from 'dayjs'
import coursePlayListIcon from 'src/assets/course_playlist_icon.png'
import closeDrawerIcon from 'src/assets/close_drawer.png'
import minimisePlayerIcon from 'src/assets/minimise_player.png'
import GlobalStyles from '@mui/material/GlobalStyles'
import { LeavingEarly } from './LeavingEarly'
import { CompletionFeedback } from './CompletionFeedback'
import { AudioPip } from './AudioPip'
import { apiURL, appVersion, platformWeb } from 'src/consumer/services'
import { Spinner } from 'react-bootstrap'
import screenfull from 'screenfull'
import { useNavigate } from 'react-router-dom'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'

const clientSessionId = uuidv4()

const clientCreatedTime = dayjs().utc().format('YYYY-MM-DD HH:mm:ss')
const offset = encodeURIComponent(getTimezoneOffset())

export default function Player({
  signedURL,
  teacherTitle,
  courseTitle,
  loading,
  courseType,
  showPlayer,
  ongoingSession,
  setOngoingSession,
  sessionsList,
  sessionId,
  courseId,
  playerType,
  userFavoriteData,
  afterRatingFunction,
  playerData,
  setPlayerData,
  congratulatoryCardData,
  setCongratulatoryCardData,
  ...props
}) {
  console.log(signedURL)
  const token = localStorage.getItem('token')
  const [isCourseDetailOpen, setIsCourseDetailOpen] = useState(false)
  const [isCoursePlaylistOpen, setIsCoursePlaylistOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)
  const [isBuffering, setIsBuffering] = useState(true)
  const [playbackRate, setPlaybackRate] = useState(1)
  const stepsArray = []
  const navigate = useNavigate()

  const [play, setPlay] = useState({
    playing: !playerData.showLeavingEarly && !playerData.showCompletionFeedback,
    played: 0,
  })

  const filteredSignedURL = signedURL.filter((step) => step !== null && step !== undefined)

  filteredSignedURL.forEach((step, index) => {
    stepsArray.push({
      url: step,
      complete: false,
      duration: 0,
      mark: parseFloat(1 / filteredSignedURL.length) * index * 100,
    })
  })

  const isSingleSession = sessionsList?.length === 1
  const deviceDetector = new DeviceDetector()
  const userAgent = navigator.userAgent
  const deviceDetials = deviceDetector.parse(userAgent)
  //const canPlayPIP = ReactPlayer.canEnablePIP(signedURL)

  let lat = 0
  let lng = 0
  if (localStorage.getItem('geoLocation') && localStorage.getItem('geoLocation') !== 'undefined') {
    const geoLocation = JSON.parse(localStorage.getItem('geoLocation'))
    lat = geoLocation?.lat || 0
    lng = geoLocation?.lng || 0
  }

  const divStyle = {
    // backgroundImage: courseType === 'video' ? 'none' : 'url(' + mediaURL + sessionsList?.[ongoingSession]?.coverImage + ')',
    // backgroundImage: courseType === 'video' ? 'none' : `url(${mediaURL}${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }

  const playerRef = useRef(null)
  const playerWithControlsRef = useRef(null)

  const handlePlayPause = () => {
    setPlay({ ...play, playing: !play.playing })
  }

  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10)
  }

  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10)
  }

  const handleProgress = (changedState) => {
    setPlay({ ...play, ...changedState })
  }

  const handleClickFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.request(playerWithControlsRef.current.wrapper)
    }
  }

  const handleExitFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.exit()
    }
  }

  // clear above this
  // not clear below this

  const handleSeekCommitted = (e, newValue) => {
    const newCurrentStep = parseInt(newValue / (100 / filteredSignedURL.length))
    if (newCurrentStep !== currentStep) {
      setCurrentStep(newCurrentStep)
      setPlay({ ...play, playing: true, played: 0 })
      playerRef.current.seekTo(0)
    } else {
      const newPlayedValue =
        (newValue - parseFloat(100 / filteredSignedURL.length) * newCurrentStep) *
        filteredSignedURL.length
      setPlay({ ...play, playing: true, played: parseFloat(newPlayedValue / 100) })
      playerRef.current.seekTo(newPlayedValue / 100)
    }
  }

  const handleSeek = (e, newValue) => {
    const newPlayedValue =
      (newValue - parseFloat(100 / filteredSignedURL.length) * currentStep) *
      filteredSignedURL.length
    setPlay({ ...play, playing: false, played: parseFloat(newPlayedValue / 100) })
    playerRef.current.seekTo(newPlayedValue / 100)
  }

  const sendSessionUpdates = async (completed = false, rating) => {
    const completedDuration = parseInt(playerRef?.current?.getCurrentTime() * 1000) || 0
    const targetDuration =
      parseInt(playerRef?.current?.getDuration() * 1000) || sessionsList?.[ongoingSession]?.duration
    const planId = playerData?.otherData?.planId || ''
    const data = getSessionProgressData({
      courseId,
      sessionId,
      targetDuration,
      completedDuration,
      completed,
      rating,
      deviceDetials,
      clientSessionId,
      clientCreatedTime,
      userAgent,
      planId,
    })
    await putSessionProgress(
      `${apiURL}/api/secure/online/courses/sessions?lat=${lat}&lng=${lng}&date=${dayjs().format(
        'YYYY-MM-DD',
      )}&zoneOffset=${offset}&minDuration=2&maxDuration=120&languageCode=${sessionStorage.getItem(
        'languageCode',
      )}&appVersion=${appVersion}&platform=${platformWeb}
    &countryCode=${localStorage.getItem('countryCode')}&src=${playerData?.source}&src-id=${
        playerData?.id
      }`,
      data,
    )
  }

  const onSessionCompleteSumbit = async (rating) => {
    await sendSessionUpdates(true, rating)
    if (playerData?.source === 'daily-play') {
      !!playerData?.otherData?.coins &&
        setCongratulatoryCardData({
          showCard: true,
          data: {
            coins: playerData?.otherData?.coins,
            completed: playerData?.otherData?.completed,
            completedItemType: 'course',
            itemData: playerData,
          },
        })
    }
    afterRatingFunction ? afterRatingFunction(handleExitFullScreen) : handleExitFullScreen()
    if (playerData?.otherData?.takeToMyPlan) {
      setPlayerData({ ...playerData, showCompletionFeedback: false, showPlayer: false })
      navigate('/my-plan', { state: { cardsData: playerData?.otherData?.cardsData } })
    }
    setPlayerData({ ...playerData, showCompletionFeedback: false, showPlayer: false })
  }

  const handleOnCompleteReplay = () => {
    setPlayerData({ ...playerData, showCompletionFeedback: false })
    setCurrentStep(0)
    setPlay({ ...play, played: 0, playing: true })
  }

  const onStepEnd = () => {
    if (currentStep === stepsArray.length - 1) {
      clearInterval(sessionUdpatesID)
      sendSessionUpdates(true)
      if (ongoingSession === sessionsList.length - 1) {
        setPlay({ ...play, playing: false })
        setPlayerData({ ...playerData, showPIP: false, showCompletionFeedback: true })
      } else {
        setOngoingSession(ongoingSession + 1)
      }
    } else {
      setCurrentStep(currentStep + 1)
      setPlay({ ...play, played: 0 })
    }
  }

  const handlePlayListClicked = (event) => {
    setAnchorEl(event.currentTarget)
    setIsCoursePlaylistOpen(!isCourseDetailOpen)
  }

  const handleEnablePIP = () => {
    console.log('enable')
  }

  const handleDisablePIP = (event) => {
    console.log('disable')
    setPlayerData({ ...playerData, showPIP: false })
  }

  let sessionUdpatesID
  useEffect(() => {
    sendSessionUpdates()
    sessionUdpatesID = setInterval(() => {
      sendSessionUpdates()
    }, 60000)
    return () => clearInterval(sessionUdpatesID)
  }, [])

  const handlePlayerClose = (event) => {
    if (screenfull.isEnabled) {
      screenfull.exit()
    }
    if (play.played >= 1) {
      setPlay({ ...play, playing: false })
      if (playerData.showPIP) {
        setPlayerData({ ...playerData, showPIP: false, showCompletionFeedback: true })
      } else {
        setPlayerData({ ...playerData, showCompletionFeedback: true })
      }
    } else {
      setPlay({ ...play, playing: false })
      if (playerType === LOOPED_PLAYER) {
        if (playerData.showPIP) {
          setPlayerData({ ...playerData, showPIP: false, showCompletionFeedback: true })
        } else {
          setPlayerData({ ...playerData, showCompletionFeedback: true })
        }
      } else {
        if (playerData.showPIP) {
          setPlayerData({ ...playerData, showPIP: false, showLeavingEarly: true })
        } else {
          setPlayerData({ ...playerData, showLeavingEarly: true })
        }
      }
    }
  }

  const handleContinuePlaying = () => {
    setPlayerData({ ...playerData, showLeavingEarly: false })
    setPlay({ ...play, playing: true })
  }

  const handleExit = (event) => {
    setPlayerData({ ...playerData, showLeavingEarly: false, showPlayer: false })
  }

  const handleDialogOpen = () => {
    setPlay({ ...play, playing: false })
  }
  const currentTime = playerRef.current ? playerRef.current.getCurrentTime() : '00:00'
  const duration = playerRef.current ? playerRef.current.getDuration() : '00:00'

  const drawerScroll = playerData.showPIP ? 'auto !important' : 'hidden !important'

  // console.log(playerData)

  return (
    <>
      <GlobalStyles styles={{ body: { overflow: drawerScroll } }} />

      <StyledDrawer
        anchor={'top'}
        open={showPlayer}
        onClose={handlePlayerClose}
        showPIP={playerData.showPIP}
      >
        {/* courseType === "video" && */}
        {!loading && (
          <StyledPlayerContainer ref={playerWithControlsRef}>
            <StyledPlayerHeader>
              <StyledHeaderButton onClick={handlePlayerClose} src={closeDrawerIcon} />
              {
                <MinimizeButton
                  onClick={() => {
                    setPlayerData({ ...playerData, showPIP: true })
                    if (screenfull.isEnabled) {
                      screenfull.exit()
                    }
                  }}
                  src={minimisePlayerIcon}
                />
              }
              {!isSingleSession && (
                <OpenPlaylistButton onClick={handlePlayListClicked} src={coursePlayListIcon} />
              )}
            </StyledPlayerHeader>

            <StyledPlayer>
              {!loading && (
                <ReactPlayer
                  ref={playerRef}
                  config={{
                    file: {
                      // forceHLS: true,
                      hlsOptions: {
                        debug: false,
                        xhrSetup: function (xhr, signedURL) {
                          xhr.setRequestHeader('Authorization', `Bearer ${token}`)
                        },
                        // enableWebVTT: true,
                      },
                    },
                  }}
                  width="100%"
                  height="100vh"
                  loop={playerType === LOOPED_PLAYER}
                  playing={play.playing}
                  style={divStyle}
                  onProgress={handleProgress}
                  pip={playerData.showPIP}
                  stopOnUnmount={!playerData.showPIP}
                  onEnablePIP={handleEnablePIP}
                  onDisablePIP={handleDisablePIP}
                  url={stepsArray?.[currentStep]?.url}
                  onEnded={() => onStepEnd()}
                  playbackRate={playbackRate}
                  // defaultSubtitle={true}
                  // onReady={() => console.log("I am ready to start")}
                  // onStart={() => console.log("I am starting")}
                  onBuffer={() => {
                    setIsBuffering(true)
                  }}
                  onBufferEnd={() => {
                    setIsBuffering(false)
                  }}
                />
              )}
            </StyledPlayer>

            {isBuffering && (
              <LoaderContainer>
                <Spinner animation="border" variant="light" style={{ width: 50, height: 50 }} />
              </LoaderContainer>
            )}

            {courseType === 'audio' && (
              // <PlayerBackgroundContainer background={sessionsList?.[ongoingSession]?.coverImage ? `${mediaURL}${sessionsList?.[ongoingSession]?.coverImage}` : `${mediaURL}${sessionsList?.[ongoingSession]?.coverIcon}`} >
              <PlayerBackgroundContainer
                background={`${APP_CONSTANTS.MEDIA_URL}${backgroundImage}`}
              >
                <PlayerBackgroundOverlay />
                <PlayerDetailsRow noSlider={playerType === LOOPED_PLAYER}>
                  <PlayerSessionImage
                    src={
                      sessionsList?.[ongoingSession]?.coverIcon
                        ? `${APP_CONSTANTS.MEDIA_URL}${sessionsList?.[ongoingSession]?.coverIcon}`
                        : `${APP_CONSTANTS.MEDIA_URL}${sessionsList?.[ongoingSession]?.coverImage}`
                    }
                  />
                  <PlayerDetailTextItems>
                    <PlayerDetailText main>
                      {sessionsList?.[ongoingSession]?.title}
                    </PlayerDetailText>
                    <PlayerDetailText>{teacherTitle}</PlayerDetailText>
                  </PlayerDetailTextItems>
                </PlayerDetailsRow>
              </PlayerBackgroundContainer>
            )}

            <PlayerControls
              handleFastForward={handleFastForward}
              handlePlayPause={handlePlayPause}
              handleRewind={handleRewind}
              handleSeek={handleSeek}
              handleSeekCommitted={handleSeekCommitted}
              currentTime={currentTime}
              playerType={playerType}
              stepsArray={stepsArray}
              currentStep={currentStep}
              duration={duration}
              play={play}
              setIsCourseDetailOpen={setIsCourseDetailOpen}
              playerRef={playerRef}
              playbackRate={playbackRate}
              setPlaybackRate={setPlaybackRate}
              handleClickFullScreen={handleClickFullScreen}
              handleExitFullScreen={handleExitFullScreen}
            />

            {isCourseDetailOpen && (
              <CourseDetails
                {...props}
                setIsOpen={setIsCourseDetailOpen}
                isSingleSession={isSingleSession}
              />
            )}

            {!isSingleSession && isCoursePlaylistOpen && (
              <PlayListContainerPopup
                open={isCoursePlaylistOpen}
                anchorEl={anchorEl}
                onClose={() => setIsCoursePlaylistOpen(false)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <CoursePlayListHeader>Series</CoursePlayListHeader>
                <CoursePlayList
                  ongoingSession={ongoingSession}
                  setOngoingSession={setOngoingSession}
                  sessionsList={sessionsList}
                  setIsOpen={setIsCoursePlaylistOpen}
                  showBackground={false}
                />
              </PlayListContainerPopup>
            )}

            {playerData.showLeavingEarly && (
              <LeavingEarly
                handleContinuePlaying={handleContinuePlaying}
                handleExit={handleExit}
                handleDialogOpen={handleDialogOpen}
                reasonsCategory={playerData?.selectedCard?.course?.category?.[0]}
              />
            )}

            {playerData.showCompletionFeedback && (
              <CompletionFeedback
                userFavoriteData={userFavoriteData}
                courseId={courseId}
                onSessionCompleteSumbit={onSessionCompleteSumbit}
                handleOnCompleteReplay={handleOnCompleteReplay}
              />
            )}
          </StyledPlayerContainer>
        )}
      </StyledDrawer>

      {courseType === 'audio' && playerData.showPIP && (
        <AudioPip
          handleDisablePIP={handleDisablePIP}
          handleFastForward={handleFastForward}
          handlePlayPause={handlePlayPause}
          handleRewind={handleRewind}
          handleSeek={handleSeek}
          handleSeekCommitted={handleSeekCommitted}
          play={play}
          handlePlayerClose={handlePlayerClose}
          ongoingSession={ongoingSession}
          sessionsList={sessionsList}
          teacherTitle={props?.teacherTitle}
          stepsArray={stepsArray}
          currentStep={currentStep}
        />
      )}
    </>
  )
}
